
import BaseView from "@core/View.js";
import Alert from "@util/alert.js";
import {$util} from "@util/util.js";
import API from "@api/index.js";
export default class SimilarityGoodstWapView extends BaseView{
    constructor(model){
        super(model);
        this._model._view = this;
        // console.log('找相似页面',this._model);

        this._parentEl = this._model._parent._view._similarityBoxEl;
        this._el = null;
    }
    getGoods() {
        let html = '';
        html += ` <div class="form">
            <div class="i_img">
                <img src="${this._model._parent._img}" alt="">
            </div>
            <div class="form_right">
                <div class="i_desc">
                <h3>${this._model._parent._name}</h3>
                <p class="service_box"> 
                    <button>已售罄</button>
                </p>
                </div>
            </div>
            </div>`
            return html;
    }
    getItems() {
        let html = '';
        for(var i=0; i < this._model._similaritygoods.length; i++) {
            var x = this._model._similaritygoods[i];
            html += `
            <div class="item_box">            
                <div class="item ">
                    <a href="${x.url.wap}" latag="latag_wap_cartOfflineGoods_recommendItem_${x.position}_${x.strategy}_${x.goodsCode}">
                        <div class="pic_box">
                            <img src="${x.thumbnail}" alt=""/>
                        </div>
                    </a>
                  <div style="width:62%;">
                    <a href="${x.url.wap}" latag="latag_wap_cartOfflineGoods_recommendItem_${x.position}_${x.strategy}_${x.goodsCode}">
                        <p class="desc">${x.name}</p>
                    </a>
                    <p class="price"><span style="position:relative;top:0.05rem;"><b class="mark">¥</b>${x.price.P_C.C_2.P_0.DV.V/*x.price.P_C.C_2.P_0.DV.V*/}</span><i class="fr iconfont icon-bill-wap-cart" data-gcode="${x.goodsCode}"></i></p>
                    </div>  
                </div>
            </div>
            `
        }
        
        
        return html;
    }

    render(){
        let html = "";
        html += `${this.getGoods()}`;
        $(this._parentEl.find("div.similarity_cart_wrap")).html($(html));
        let str = "";
        str += `${this.getItems()}`
        $(this._parentEl.find("div.recommend_box .recommend_content")).html($(str));
        this._el = $(".similarity_wap_wrapper");
        // 每次render都清空选择了几件服务
        this.regEvent();
    }
    regEvent() {
        let that = this;
        // 点击选择服务叉号, 隐藏弹窗icon-close
        this._el.off("click", ".icon-close").on("click", ".icon-close", function () {
            $(".similarity_wap_wrapper").hide();
            $util.toggleBodyScroller(false);
        })
        this._el.off("click", ".icon-bill-wap-cart").on("click", ".icon-bill-wap-cart", function () {
            let codes = $(this).attr('data-gcode');
            let _params ={               
                itemtype: 0, //0 单品, 2 选件, 3套餐 找相似只能加入单品
                gcodes: codes,//1005304
                icount:1
            }
            that._model._parent.addGoodsToCard(_params).then(x=>{
                $(".similarity_wap_wrapper").hide();  
                $util.toggleBodyScroller(false);   
                API.getCart().then(x=>{
                    _engine._currentTime = x.t.timestamp;
                    const nowDate = new Date();
                    //客户本地时间与服务器时间的差值
                    _engine._timeDiff = _engine._currentTime - nowDate.getTime();
                    _engine.reRenderCart(x.t);
                    _engine._price.init(x.t);
                    _engine._price._view.render();
                })
                  
            }).catch(err => {
                Alert.showTip(err.msg);
            });
        })
    }
}

